export default __webpack_public_path__ + "locales/sl/FillPDFDialog.json?hash=548cb77cbffeae26ad693af5bea245e9";